interface Bank {
  key: string;
  label: string;
}

export class BankValidator {
  private static validBanks: Set<string> = new Set();

  static updateValidBanks(banks: Bank[] | undefined): void {
    if (!banks) return;
    this.validBanks = new Set(banks.map((bank) => bank.key));
  }

  static isValidBank(bankKey: string): boolean {
    return this.validBanks.has(bankKey);
  }
}
